module.exports = __webpack_public_path__ + "static/media/KGantin-96-9.6507d4b0.jpg";